import { render, staticRenderFns } from "./HiprintTest.vue?vue&type=template&id=2a04db0a&scoped=true"
import script from "./HiprintTest.vue?vue&type=script&lang=js"
export * from "./HiprintTest.vue?vue&type=script&lang=js"
import style0 from "./HiprintTest.vue?vue&type=style&index=0&id=2a04db0a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a04db0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a04db0a')) {
      api.createRecord('2a04db0a', component.options)
    } else {
      api.reload('2a04db0a', component.options)
    }
    module.hot.accept("./HiprintTest.vue?vue&type=template&id=2a04db0a&scoped=true", function () {
      api.rerender('2a04db0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/test/HiprintTest.vue"
export default component.exports